import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const ClosingCta = () => (
  <section
    id="contact"
    data-testid="closing-cta"
    className="grain relative overflow-hidden border-t border-[#233c4d]/25"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(50% 60% at 50% 100%, rgba(255,138,76,0.12) 0%, rgba(35,60,77,0.25) 45%, rgba(11,16,13,0) 100%)",
      }}
    />
    <div className="relative mx-auto max-w-7xl px-6 py-28 md:px-12 md:py-40">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-end"
      >
        <div>
          <span className="eyebrow">Let’s start with your use case.</span>
          <h2 className="mt-4 text-4xl font-medium tracking-tight text-[#f3f5f3] md:text-5xl lg:text-6xl">
            Make knowledge
            <br />
            <span className="text-[#889296]">work harder.</span>
          </h2>
        </div>
        <div className="flex flex-col items-start gap-6">
          <p className="text-sm leading-relaxed text-[#889296] md:text-base">
            Tell us what people need to find.
            <br />
            Let’s build their way to it.
          </p>
          <a
            href="https://cal.com/wondersearch/15min"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="closing-book-call-btn"
            className="inline-flex items-center gap-3 rounded-full bg-[#f3f5f3] px-8 py-4 text-sm font-semibold text-[#0b100d] transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:shadow-[0_12px_44px_rgba(255,138,76,0.25)]"
          >
            <span className="flex gap-1" aria-hidden="true">
              <i className="h-1.5 w-1.5 rounded-[2px] bg-[#ff8a4c]" />
              <i className="h-1.5 w-1.5 rounded-[2px] bg-[#ffc42e]" />
              <i className="h-1.5 w-1.5 rounded-[2px] bg-[#ff8a4c]" />
            </span>
            Book a call <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
